export default "__VITE_ASSET__CddGPMD7__"